<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <form @submit.prevent="addCustomService">
            <div class="">
                <div class="h2">Add new custom service</div>
                <div class="">
                    <div class="container-fluid bg-light py-3">
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm">
                                    <div class="form-group">
                                        <div><strong>Name</strong></div>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="!customService.name && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Custom service name"
                                                   v-model="customService.name"
                                                   @input="clearError('name')"
                                            >
                                        </div>
                                        <div class="text-danger" v-if="errors.name">{{ errors.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary" @click="validation()">Save</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <a href="/products" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>
    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "CustomServiceCreate",
    data() {
        return {
            customService: {},
            isSubmit: false,
            errors: {}
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        clearError(field) {
            this.$set(this.errors, field, null);
        },
        addCustomService() {
            this.errors = {};
            axios.post('/custom-services', this.customService).then((response) => {
                window.location.href = `/products`;

            }).catch(err => {
                this.flashMessage.error({
                    title: '',
                    message: err.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(err.response.data);
                if (err.response.data.errors) {
                    if (err.response.data.errors.name) {
                        this.$set(this.errors, 'name', err.response.data.errors.name[0]);
                    }
                }
            });
        }
    }
}

</script>
